import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private base = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCompanies(): Observable<any[]> {
    return this.http.get<any>(`${this.base}/companies`)
      .pipe(map(r => r.data.companies));
  }

  getBranches(companyId: string): Observable<any[]> {
    return this.http.get<any>(`${this.base}/companies/${companyId}/branches`)
      .pipe(map(r => r.data.branches));
  }

  getCompany(companyId: string): Observable<any> {
    return this.http.get<any>(`${this.base}/companies/${companyId}`)
      .pipe(map(r => r.data.company));
  }

  getBranch(companyId: string, branchId: string): Observable<any> {
    return this.http.get<any>(`${this.base}/companies/${companyId}/branches/${branchId}`)
      .pipe(map(r => r.data.branch));
  }

  getSources(companyId: string, branchId: string): Observable<any[]> {
    return this.http.get<any>(`${this.base}/companies/${companyId}/branches/${branchId}/sources`)
      .pipe(map(r => r.data.sources));
  }

  getDashboard(companyId: string, branchId: string, sourceId?: string, date?: string): Observable<any> {
    const url = `${this.base}/companies/${companyId}/branches/${branchId}/dashboard`;
    const params: Record<string, string> = {};
    if (sourceId) params['source_id'] = sourceId;
    if (date) params['date'] = date;
    return this.http.get<any>(url, { params })
      .pipe(map((r: any) => r.data.dashboard));
  }
}
